export default {
  state: {
    createEditComponent: null,
    createEditComponentData: null,
    createEditComponentIsShown: false
  },
  mutations: {
    setCreateEditComponent(state, component) {
      state.createEditComponent = component;
    },
    setCreateEditComponentData(state, data) {
      state.createEditComponentData = data;
    },
    setCreateEditComponentIsShown(state, bool) {
      state.createEditComponentIsShown = bool;
    },
    setCreateEditComponentParams(state, params) {
      Object.keys(params).forEach(key => {
        state[key] = params[key];
      });
    },
    resetCreateEditComponentParams(state) {
      state.createEditComponent = null;
      state.createEditComponentData = null;
      state.createEditComponentIsShown = false;
    }
  }
};
